import React, { useState } from 'react'

interface ReadMoreProps {
    text: string;
    maxLength?: number;
  }

const ReadMoreLess: React.FC<ReadMoreProps>  = ({text, maxLength = 100}) => {

    const [isExpanded, setIsExpanded] = useState(false);
    const toggleReadMore = () => setIsExpanded(!isExpanded);

  return (
    <div className="text-gray-700">
        <p>
            {isExpanded && text ? text : `${text.slice(0, maxLength)}...`}
            <button
            onClick={toggleReadMore}
            className="ml-2 text-[#D06F1A] font-MetropolisBold hover:underline"
          >
            {isExpanded ? "Read Less" : "Read More"}
          </button>
        </p>
    </div>
  )
}

export default ReadMoreLess